module.exports = __webpack_public_path__ + "static/media/Wine-House.dd6bd42f.png";